export const LMS_RESIZED = 'LMS_RESIZED';